import Head from 'next/head'
import React from 'react'

import { useTranslation } from 'hooks/useTranslation'
import { Home } from 'features/Home'

export default function LandingPage() {
  const { t } = useTranslation()

  return (
    <div>
      <Head>
        <title>{t('home:page-title')}</title>
        <meta name="title" content={t('home:meta-title')} />
        <meta name="description" content={t('home:meta-description')} />
        <link rel="icon" href="/favicon.ico" />
      </Head>
      <Home />
    </div>
  )
}
